import { functions } from '..'

export async function checkPixInfo(pixKey: string) {
  await functions.httpsCallable('payments-getBrlaPixInfo')({ pixKey })
}
